// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { authApi } from "../../config/api";
// import { toast } from "react-toastify";

// // GET - Assigned or Published Hotlists
// export const getAssignedOrPublishedHotLists = createAsyncThunk(
//   "hotlistRec/fetchAssignedOrPublished",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await authApi.get(
//         "/company/recruiter/hot-list/assigned-or-published-by-bench-sale/"
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // GET - Chat messages for a candidate
// export const getHotlistChatByCandidateId = createAsyncThunk(
//   "hotlistRec/getHotlistChatByCandidateId",
//   async (candidateId, { rejectWithValue }) => {
//     try {
//       const response = await authApi.get(
//         `/company/recruiter/hot-list/chat/${candidateId}/`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // POST - Send a chat message
// export const sendHotlistChatMessage = createAsyncThunk(
//   "hotlistRec/sendHotlistChatMessage",
//   async (messageData, { rejectWithValue }) => {
//     try {
//       const response = await authApi.post(
//         `/company/recruiter/hot-list/chats/send/`,
//         messageData
//       );
//       toast.success("Message sent successfully");
//       return response.data;
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to send message");
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// const hotListRecSlice = createSlice({
//   name: "hotlistRec",
//   initialState: {
//     hotLists: [],
//     chatMessages: [],
//     status: "idle",
//     error: null,
//     loading: {
//       getAssignedOrPublishedHotLists: "idle",
//       getHotlistChatByCandidateId: "idle",
//       sendHotlistChatMessage: "idle",
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Assigned or Published Hotlists
//       .addCase(getAssignedOrPublishedHotLists.pending, (state) => {
//         state.loading.getAssignedOrPublishedHotLists = "pending";
//         state.status = "loading";
//       })
//       .addCase(getAssignedOrPublishedHotLists.fulfilled, (state, action) => {
//         state.loading.getAssignedOrPublishedHotLists = "succeeded";
//         state.hotLists = action.payload.results || action.payload;
//         state.status = "succeeded";
//       })
//       .addCase(getAssignedOrPublishedHotLists.rejected, (state, action) => {
//         state.loading.getAssignedOrPublishedHotLists = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         // toast.error(
//         //   action.payload?.message ||
//         //     "Failed to fetch assigned or published hotlists"
//         // );
//       })

//       // Chat Messages
//       .addCase(getHotlistChatByCandidateId.pending, (state) => {
//         state.loading.getHotlistChatByCandidateId = "pending";
//       })
//       .addCase(getHotlistChatByCandidateId.fulfilled, (state, action) => {
//         state.loading.getHotlistChatByCandidateId = "succeeded";
//         state.chatMessages = action.payload.results || action.payload;
//       })
//       .addCase(getHotlistChatByCandidateId.rejected, (state, action) => {
//         state.loading.getHotlistChatByCandidateId = "failed";
//         state.error = action.payload;
//         state.chatMessages = [];
//         // toast.error(action.payload?.message || "Failed to fetch chat messages");
//       })

//       // Send Chat Message
//       .addCase(sendHotlistChatMessage.pending, (state) => {
//         state.loading.sendHotlistChatMessage = "pending";
//       })
//       .addCase(sendHotlistChatMessage.fulfilled, (state, action) => {
//         state.loading.sendHotlistChatMessage = "succeeded";
//         // Optionally push the new message to chatMessages
//         state.chatMessages = [
//           ...(Array.isArray(state.chatMessages) ? state.chatMessages : []),
//           action.payload,
//         ];
//       })
//       .addCase(sendHotlistChatMessage.rejected, (state, action) => {
//         state.loading.sendHotlistChatMessage = "failed";
//         state.error = action.payload;
//       });
//   },
// });

// export default hotListRecSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../config/api";
import { toast } from "react-toastify";

// GET - Assigned or Published Hotlists
export const getAssignedOrPublishedHotLists = createAsyncThunk(
  "hotlistRec/fetchAssignedOrPublished",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        "/company/recruiter/hot-list/assigned-or-published-by-bench-sale/"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// GET - Chat messages for a candidate
export const getHotlistChatByCandidateId = createAsyncThunk(
  "hotlistRec/getHotlistChatByCandidateId",
  async (candidateId, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/company/recruiter/hot-list/chat/${candidateId}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// GET - Chat detail by hotlistId and candidateId
export const getHotlistChatDetailByIds = createAsyncThunk(
  "hotlistRec/getHotlistChatDetailByIds",
  async ({ hotlistId, candidateId }, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/company/recruiter/hot-list/chat-detail/${candidateId}/${hotlistId}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// POST - Send a chat message
export const sendHotlistChatMessage = createAsyncThunk(
  "hotlistRec/sendHotlistChatMessage",
  async (messageData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        `/company/recruiter/hot-list/chats/send/`,
        messageData
      );
      toast.success("Message sent successfully");
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send message");
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const hotListRecSlice = createSlice({
  name: "hotlistRec",
  initialState: {
    hotLists: [],
    chatMessages: [],
    chatDetail: [],
    status: "idle",
    error: null,
    loading: {
      getAssignedOrPublishedHotLists: "idle",
      getHotlistChatByCandidateId: "idle",
      getHotlistChatDetailByIds: "idle",
      sendHotlistChatMessage: "idle",
    },
  },
  extraReducers: (builder) => {
    builder
      // Assigned or Published Hotlists
      .addCase(getAssignedOrPublishedHotLists.pending, (state) => {
        state.loading.getAssignedOrPublishedHotLists = "pending";
        state.status = "loading";
      })
      .addCase(getAssignedOrPublishedHotLists.fulfilled, (state, action) => {
        state.loading.getAssignedOrPublishedHotLists = "succeeded";
        state.hotLists = action.payload.results || action.payload;
        state.status = "succeeded";
      })
      .addCase(getAssignedOrPublishedHotLists.rejected, (state, action) => {
        state.loading.getAssignedOrPublishedHotLists = "failed";
        state.status = "failed";
        state.error = action.payload;
      })

      // Chat Messages
      .addCase(getHotlistChatByCandidateId.pending, (state) => {
        state.loading.getHotlistChatByCandidateId = "pending";
      })
      .addCase(getHotlistChatByCandidateId.fulfilled, (state, action) => {
        state.loading.getHotlistChatByCandidateId = "succeeded";
        state.chatMessages = action.payload.results || action.payload;
      })
      .addCase(getHotlistChatByCandidateId.rejected, (state, action) => {
        state.loading.getHotlistChatByCandidateId = "failed";
        state.error = action.payload;
        state.chatMessages = [];
      })

      // Chat Detail by Hotlist and Candidate ID
      .addCase(getHotlistChatDetailByIds.pending, (state) => {
        state.loading.getHotlistChatDetailByIds = "pending";
      })
      .addCase(getHotlistChatDetailByIds.fulfilled, (state, action) => {
        state.loading.getHotlistChatDetailByIds = "succeeded";
        state.chatDetail = action.payload.results || action.payload;
      })
      .addCase(getHotlistChatDetailByIds.rejected, (state, action) => {
        state.loading.getHotlistChatDetailByIds = "failed";
        state.error = action.payload;
        state.chatDetail = [];
      })

      // Send Chat Message
      .addCase(sendHotlistChatMessage.pending, (state) => {
        state.loading.sendHotlistChatMessage = "pending";
      })
      .addCase(sendHotlistChatMessage.fulfilled, (state, action) => {
        state.loading.sendHotlistChatMessage = "succeeded";
        state.chatMessages = [
          ...(Array.isArray(state.chatMessages) ? state.chatMessages : []),
          action.payload,
        ];
      })
      .addCase(sendHotlistChatMessage.rejected, (state, action) => {
        state.loading.sendHotlistChatMessage = "failed";
        state.error = action.payload;
      });
  },
});

export default hotListRecSlice.reducer;
